/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Nav from "@components/nav"
import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "gpages/hooks/layout"

const Layout = ({ children, location }) => {
  const { isAppLayout, renderItem } = useBrowserLayout()
  if (isAppLayout === undefined) {
    return null
  }

  return (
    <AppContext.Provider value={{ isAppLayout, renderItem }}>
      <Seo />
      <Nav location={location} />
      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <footer className={styles.footer}>
        <div className={styles.footerLeft}>
          <a href="https://www.gcores.com">www.gcores.com</a>
          {/* <p>some logos here</p> */}
        </div>
        <div className={styles.footerRight}>
          GCORES 2023 ALL RIGHTS RESERVED
        </div>
      </footer>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
